export default {
  title: 'AITA.center',
  backToDashboard: 'Back to dashboard',
  launchSoon: 'Launching soon',
  heroTag: 'Gonka Game AI centre',
  heroTitle: 'AI models —',
  heroHighlight: 'all in one place.',
  heroLead:
    'Write text, create images and videos, and work with documents. Popular AI models and ready-to-use tools, together.',
  accessNote: 'In Russian · Pay in rubles · No VPN',
  ssoNote: 'Sign in with Gonka Game',
  mascotAlt: 'Gonka Game character holding a board with AI model logos',
  demoLabel: 'Example tool output',
  demoPrompt: 'Write a post about a new product',
  demoAnswer:
    'Meet our new product! It helps you create content faster and save time. Try it and tell us what you think.',
  previewLabel: 'Example',
  openCenter: 'Open AITA.center',
  whatItDoes: 'Features',
  networksValue: '25+',
  networksLabel: 'AI models',
  toolsValue: '100+',
  toolsLabel: 'ready-to-use tools',
  textFrom: 'text from',
  textPrice: '$0.01',
  painTag: 'sound familiar?',
  painTitle: 'One task — several open tabs?',
  painLead:
    'A post needs text, an image and a short video. You would rather not put them together across different services.',
  painPayment: 'You have no way to pay for a foreign subscription',
  painVpn: 'Some services are unavailable without a VPN',
  painSwitching:
    'You have to switch between services for text, images and video',
  painInterface: 'An unfamiliar interface makes it hard to know where to start',
  painTrial: 'You do not want to pay before trying it',
  featuresTag: 'features',
  featuresTitle: 'From idea to result.',
  featuresLead:
    'Write a post, create an image and a short video to go with it. You can also prepare a reply to a customer or analyse a document here — without switching to another service.',
  textsTitle: 'Text and documents',
  textsDescription: 'Posts, customer replies, scripts and file analysis.',
  imagesTitle: 'Images',
  imagesDescription: 'Covers, banners and product cards.',
  videoTitle: 'Video',
  videoDescription: 'Short videos from a description or a photo.',
  assistantsTitle: 'AI assistants',
  assistantsDescription: 'Ideas for content, marketing and sales.',
  assistantsCount: '6 assistants',
  voiceInput: 'voice input',
  tasksTag: 'ready-to-use tools',
  tasksTitle: 'Start with a familiar task.',
  tasksLead: 'Choose a tool and describe what you want to create.',
  telegramTitle: 'Telegram post',
  telegramDescription:
    'Specify the topic and your audience — get text for your channel.',
  instagramTitle: 'Instagram carousel',
  instagramDescription:
    'Present a product or explore a topic in a series of slides with text and images.',
  marketplaceTitle: 'Product card',
  marketplaceDescription:
    'Show a product and its features in an image for Wildberries or Ozon.',
  transcriptionTitle: 'Broadcast transcription',
  transcriptionDescription:
    'Upload a video or voice message — get a transcript, a summary or material for a post.',
  photoTitle: 'Improve a photo',
  photoDescription:
    'Remove an unwanted background, improve photo quality or show an object from a different angle.',
  reportTitle: 'Analyse a report',
  reportDescription:
    'Upload an Excel file or PDF and ask questions about the data — you do not have to work through the whole file alone.',
  previousCard: 'Previous card',
  nextCard: 'Next card',
  audienceTag: 'who it is for',
  audienceTitle: 'For work. For your own ideas.',
  bloggersTitle: 'You run a blog',
  bloggersDescription: 'Create posts, images and short videos.',
  sellersTitle: 'You sell online',
  sellersDescription: 'Present your products and reply to customers.',
  beginnersTitle: 'You are new to AI',
  beginnersDescription: 'Start with a ready-to-use tool.',
  startTag: 'how to start',
  startTitle: 'Three steps to your first result.',
  accountTitle: 'Open AITA.center',
  accountDescription:
    'Sign in with your Gonka Game account to access AITA.center.',
  chooseTitle: 'Choose a task',
  chooseDescription: 'Write a prompt or open a ready-to-use tool.',
  reviewTitle: 'Check the result',
  reviewDescription:
    'Download the result. Before publishing, check the text, facts and details in the image.',
  pricingTag: 'plans',
  pricingTitle: 'Start for free.',
  pricingLead:
    'Choose a plan and spend credits on your tasks. The cost depends on the model and format.',
  planAudienceHeading: 'Best for',
  freePurpose: 'Getting to know the service',
  starterPurpose: 'Your own tasks',
  proPurpose: 'Regular work',
  viewPlans: 'View plans in AITA.center',
  priceTextTag: 'Text',
  priceTextValue: 'from $0.01',
  priceTextDescription: 'a post or description',
  priceImageTag: 'Images',
  priceImageValue: 'from $0.05',
  priceImageDescription: 'one generation',
  priceVideoTag: '5-second video',
  priceVideoValue: 'from $0.40',
  priceVideoDescription: 'one video',
  planHeading: 'Plan',
  priceHeading: 'Price',
  capacityHeading: 'Approximately enough for',
  freePlan: 'Free',
  freePrice: '$0',
  freeCapacity: 'a trial',
  starterPlan: 'Starter',
  starterPrice: '$9/month',
  starterCapacity: '~180 images, or ~22 videos, or ~900 texts',
  proPlan: 'Pro',
  proPrice: '$19/month',
  proCapacity: '~380 images, or ~47 videos + unlimited Gemini and DeepSeek',
  faqTag: 'questions',
  faqTitle: 'Frequently asked questions',
  vpnQuestion: 'Do I need a VPN?',
  vpnAnswer:
    'No. The service works from Russia. It is better to turn off your VPN when paying — banks may decline the payment.',
  beginnerQuestion: 'I have never used AI models. Where do I start?',
  beginnerAnswer:
    'Choose a familiar task, such as a post for your channel. A ready-to-use tool will help you put together a prompt. The interface is in Russian; you can use voice input instead of typing.',
  creditsQuestion: 'What are credits?',
  creditsAnswer:
    'They are internal units used to pay for tasks on the platform. Credits are deducted during generation; usage depends on the model and task. Text usually requires fewer credits than video. You can check the current plan details in AITA.center.',
  commercialQuestion: 'Can I use the results for work and advertising?',
  commercialAnswer: 'Yes, commercial use is allowed on paid plans.',
  modelsQuestion: 'Why use the platform if ChatGPT already exists?',
  modelsAnswer:
    'Here you can choose different models for text, images and video within one account. There is no need to switch to another service to add an image or a short video to a post. You do not need a VPN for access or a foreign bank card for payment.',
  finalTitle: 'Start with your own task.',
  finalDescription: 'A post, an image or a video — choose what you need today.',
}
